/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { type ReactNode } from 'react';

import { jsx } from '@compiled/react';

import { cssMap, cx } from '@atlaskit/css';
import { Box, Flex, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
const styles = cssMap({
	labelStyle: {
		display: 'flex',
		width: '100px',
		maxWidth: '100px',
		color: token('color.text.subtle', '#44546F'),
		alignItems: 'flex-start',
		gap: token('space.0', '0px'),
	},
	valueStyle: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: token('space.075', '6px'),
		color: token('color.text', '#172B4D'),
		overflowWrap: 'anywhere',
		wordBreak: 'break-word',
		minWidth: '0px', // Allow flex item to shrink
		flex: '1', // Take remaining space
	},
});

interface DetailsRowProps {
	label: string;
	value: ReactNode;
}

export const DetailsRow = ({ label, value }: DetailsRowProps): JSX.Element | null => {
	if (value === null || value === undefined || value === '') {
		return null;
	}

	return (
		<Flex gap="space.100">
			<Box xcss={cx(styles.labelStyle)}>
				<Text color="inherit">{label}</Text>
			</Box>
			<Box xcss={cx(styles.valueStyle)}>{value}</Box>
		</Flex>
	);
};
